/**
 * Tells whether a user is active or not after a period of time.
 */

import { throttle } from '../utils/throttle';

let isServiceInitialized = false;
let lastActivity;

const events = [
  'scroll',
  'click',
  'resize',
  'keypress',
  'touchmove',
  'mousemove',
  'mousewheel'
];

const logActivity = throttle(() => {
  lastActivity = Date.now();
}, 1000);

export const userActivityService = {
  init: () => {
    if (!isServiceInitialized) {
      lastActivity = Date.now();
      events.forEach(event => window.addEventListener(event, logActivity));
      isServiceInitialized = true;
    }
  },
  /**
   * This isn't usually called as this service is mainly used by ads, which
   * are present in all pages.
   */
  destroy: () => {
    if (isServiceInitialized) {
      events.forEach(event => window.removeEventListener(event, logActivity));
      isServiceInitialized = false;
    }
  },

  /**
   * @param {int} threshold - Seconds to consider a user non-active
   */
  isActive: (threshold = 60) => {
    userActivityService.init();
    return lastActivity + threshold * 1000 > Date.now();
  }
};
